const {KitModule, registerModule} = window;

class RotatingTitle extends KitModule {
  constructor($element) {
    super($element);

    this.repeat = this.repeat.bind(this);

    this.setVars();

    if (this.header && this.isDesktop) {
      this.header.style.transform = 'translateY(-100%)';
    }

    setTimeout(() => {
      if (this.header && this.isDesktop) {
        this.header.style.transform = 'none';
      }
      document.body.classList.add('animate--on');
    }, 600);

    this.raf = window.requestAnimationFrame(this.repeat);

    this.bindEvents();
  }

  setVars() {
    this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    this.offset = this.$wordSlider.clientHeight;
    this.index = -1;
    this.timeout = 2000;
    this.lastIntervalTimestamp = 0;
    this.raf = undefined;
  }


  bindEvents() {
    window.addEventListener('resize', this);
  }

  onresize() {
    this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    this.offset = this.$wordSlider.clientHeight;
  }

  animate(index) {
    this.$wordSlider.style.transform = `translateY(-${this.offset * index}px)`;
  }

  repeat(now) {
    if ((!this.lastIntervalTimestamp || now - this.lastIntervalTimestamp >= this.timeout)) {
      this.lastIntervalTimestamp = now;
      this.index++;

      this.animate(this.index);
    }

    if (this.index == this.$wordSlider.children.length) {
      this.index = -1;
      this.lastIntervalTimestamp = 0;
      this.$wordSlider.style.transform = `translateY(-${this.offset}px)`;
    }
    this.raf = window.requestAnimationFrame(this.repeat);
  }
}

registerModule('RotatingTitle', RotatingTitle);
